<template>
  <!-- <div class="header-background"></div> -->
  <div class="carousel">  
    <div class="header-background"></div>

  </div>

  <div class="content">
    <h1 style="text-align: center; line-height: 50px;margin-bottom: 40px;">
      基于大模型的区块链供应链金融营运仿真博弈平台(沙盘版/PC 版)
    </h1>
    <el-affix target=".content" :offset="0" class="el-affix">
    <div class="button-container">
      <button
        v-for="(item, index) in buttons"
          :key="index"
          v-show="isButtonVisible"
          class="icon-button fixed-button"
          :class="['icon-' + index, { 'active-button': activeIndex === index }]"
          ref="button"
          @click="scrollToContent(index)"
        >
          {{ item.label }}
        </button>
    </div>
  </el-affix>
  <el-card class="contentCard">
        <h1 style="color: #ff8a00;" id="content-0">产品简介</h1>
        <p style="text-align: left; padding-left: 20px; padding-right: 20px;font-size: 16px; padding-top: 20px; line-height: 30px; text-indent: 2em;">
          针对数字化背景下金融经营管理专业人才培养的博弈沙盘实训系统，构建出供应链环境、竞争环境和市场环境，学生灵活运用供应链金融管理的相关知识进行分析决策。系统支持多角色、多环节、互动式操作，并采用AIGC技术，覆盖智能风控、智能授信管理等典型AIGC应用场景，集趣味性、前沿性、真实性、实用性于一体。
        </p>
        <div class="image1"></div>
        <!-- 适用专业 -->
        <h1 style="color: #ff8a00; margin-top: 30px;" id="content-1">适用专业</h1>
        <p class="pcontent">
          金融管理、数字经济、数字贸易等等相关专业。
        </p>

        <!-- 适用课程 -->
        <h1 style="color: #ff8a00; margin-top: 30px;" id="content-2">适用课程</h1>
        <p class="pcontent">
          《金融科技学》、《金融工程概论》、《区块链技术及应用》、《供应链金融营运仿真实训》等。
        </p>
        
        <!-- 主要功能： -->
        <h1 style="color: #ff8a00; margin-top: 30px;" id="content-3">主要功能</h1>
        <div class="image-background" style="margin-top: 10px;"></div>

        <!-- 教学目标 -->
        <h1 style="color: #ff8a00; margin-top: 20px;" id="content-4">教学目标</h1>
        <p class="pcontent"> 
          系统分别设置了债权开立、债权流转、债权融资、债权兑付、区块链运维、产品管理等不同模块，设置了核心企业、一级供应商、二级供应商、金融机构、平台运营机构、区块链管理员等不同角色，同时根据实践中不同规模供应链金融所必须的经营决策节点进行编排。学生通过不同角色的仿真实践，能够掌握供应链金融的关键业务操作，领会供应链金融对维护供应链稳定、提高核心企业资金周转率和利用率所起到的关键作用。
        </p>
       
      </el-card>
  </div>

  <div class="image">
    <div class="text-container">
      <div class="company-name">晨鸟科技</div>
      <div class="expertise">数字教育服务专家</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      buttons: [
        {
          title:`产品简介`,
           label: "产品简介", 
           content: 
           `
           
           ` ,
           index: 0, 
        },
        { title:`适用专业`,label: "适用专业", content: "这里大赛组织的内容",index: 1,},
        { title:`适用课程`,label: "适用课程", content: "这里是参赛方式的内容",index:2,},
        { title:`主要功能`,label: "主要功能", content: "这里是大赛内容的内容",index:3,},
        { title:`教学目标`,label: "教学目标", content: "这里是时间安排的内容",index:4,},
       
      ],
      activeIndex: -1,
      contentHeight: [],
      defaultHeight: 410,
      isButtonVisible: true,
    };
  },
  mounted() {
    this.activeIndex = 0; 
    this.updateActiveIndexOnScroll();
    window.addEventListener('scroll', this.checkScrollPosition);
    window.addEventListener('scroll', this.updateActiveIndexOnScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.checkScrollPosition);
    window.removeEventListener('scroll', this.updateActiveIndexOnScroll);
  },
  methods: {
    scrollToContent(index) {
    this.activeIndex = index;
    const contentElement = document.getElementById('content-' + index);
    if (contentElement) {
      contentElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  },
  checkScrollPosition() {
      const headerHeight = 1630; // 头部的高度，根据实际情况调整
      const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      if (currentScrollPosition > headerHeight) {
        this.isButtonVisible = false;
      } else {
        this.isButtonVisible = true;
      }
    },
  updateActiveIndexOnScroll() {
      let scrollY = window.scrollY;
      let activeIndex = -1;
      this.buttons.forEach((button, index) => {
        let contentElement = document.getElementById('content-' + index);
        if (contentElement.getBoundingClientRect().top <= window.innerHeight) {
          activeIndex = index;
          return false; 
        }
      });
      if (activeIndex !== this.activeIndex) {
        this.activeIndex = activeIndex;
      }
    }
  },
};
</script>

<style scoped>
.header-background {
  background-image: url("/src/images/potato/001.png");
  width: 1100px;
  height: 371px;
  position: relative;
  background-size: cover;
  background-position: center;
  display: block;
  object-fit: cover;
  object-position: center;
  margin: 0 auto;
}

.carousel {
  position: relative;
  width: 100%; 
  height: 371px;
  background-color: #f2f3f5; 
  overflow: hidden; 
  margin: 0 auto;
  top: 80px;
}

.content {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: auto;
  background-color: #f2f3f5;
  overflow: hidden;
  padding-top: 100px;
}

.button-container {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  top:  81px; 
  z-index: 100;
}
button:hover {
  background-color: #ff8a00;
  color: #ffffff;
}
button {
  width: 170px;
  height: 50px;
  margin-bottom: 10px;
  padding: 10px 20px;
  background-color: #ffffff;
  color: #333333;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;

}

.image {
  width: 100%;
  height: 200px;
  background-image: url("/src/images/Ima/落版.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.text-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: auto;
  max-width: 800px;
  padding: 20px;
  box-sizing: border-box;
  margin: 0 auto;
  white-space: nowrap;
}

.company-name {
  background-color: #ff8a00;
  color: white;
  padding: 10px 20px;
  border: 1px solid #ff8a00;
  border-radius: 5px;
  text-align: center;
  font-size: 24px;
  margin-right: 20px;
  line-height: 1;
}

.expertise {
  color: #090909;
  font-size: 36px;
  text-align: left;
  margin-left: 10px;
}

.icon-button {
  width: 170px;
  height: 50px;
  padding-left: 60px;
  background-size: 25px 25px; /* 图片大小调整 */
  background-repeat: no-repeat;
  background-position: 25px center;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  margin-left: -550px;
}

.icon-0 {
  background-image: url("/src/images/potato/产品简介图标.png");
}

.icon-1 {
  background-image: url("/src/images/potato/适用专业.png");
}
.icon-2 {
  background-image: url("/src/images/potato/适用课程图标.png");
}

.icon-3 {
  background-size: 25%;
  background-position: 15px center;
  background-image: url("/src/images/potato/主要功能入口.png");
}
.icon-4 {
  background-image: url("/src/images/potato/教学目标图标.png");
}

.card-content {
  min-height: 410px;
  width: 900px;
  margin-left: 200px;
  margin-top: -420px;
  overflow: hidden;
}

.auto-height {
  overflow: auto;
}
.active-button {
  background-color: #ff8a00;
  color: #ffffff;
}


.contentCard {
  overflow: hidden;
  width: 900px;
  height: auto;
  margin-left:200px;
  margin-top: -300px;
}
.pcontent{
  text-align: left;
  padding-left: 20px;
  padding-right: 20px;
  font-size: 16px;
  padding-top: 10px;
  line-height: 30px;
  text-indent: 2em;
}
.image-background {
width: 100%;
height: 420px;
background-repeat: no-repeat;
background-size: 80%;
background-position: center;
background-image: url('/src/images/potato/区块链供应链金融营运仿真博弈沙盘主要功能.png');
}
.image1{
    width: 100%;
    height: 400px;
    background-repeat: no-repeat;
    background-size: 80%;
    background-position: center;
    background-image: url('/src/images/potato/区块链金融简介清晰图.jpg');
}
.el-affix{
  z-index: 0;
}
</style>
